export let skypeEnterpriseCharm_ariaLabel = "SaFXzd";
export default {skypeEnterpriseCharm_ariaLabel};